import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import Router from './Router.js'
import { containerReload, eventsGlobal } from './tagcommander'

Vue.use(Vuex)

const state = {
  authToken: null,
  authError: null,
  user: null,
  currentOrder: null,
  filters: [],
  currentFilter: 'recents',
  statusColor: {
    'in-progress': 'in-progress',
    'canceled': 'canceled',
    'partial-shipment': 'partial-shipment',
    'shipped': 'shipped'
  },
  orders: null,
  searchConfig: {
    keywords: '',
    status: ['all'],
    flags: [],
    period: ['6-month']
  },
  searchLoading: false,
  order: null,
  formLogin: false
}

const getters = {
  filteredOrders: state => {
    switch (state.currentFilter) {
      case 'notifications':
        return !state.orders ? state.orders : _.filter(state.orders, value => {
          return value.delivery && (value.delivery.dateIsDifferent || value.delivery.dateHasChanged)
        })

      case 'recents':
      default:
        return state.orders
    }
  }
}

const actions = {
  authUser: ({ commit, dispatch }, formData) => {
    formData.country = 'fr' // TODO dynamiser
    return Vue.http.post(process.env.API_URL + '/login', formData).then(
    (response) => {
      commit('userAuthSuccess', response.body.token)

      // Get the user info
      dispatch('getUserInfo', response.body.token)

      Router.push({ name: 'order-list' })
    },
    (response) => {
      commit('userAuthFail', { code: 401, message: 'Nom d\'utilisateur ou mot de passe incorrect' })
    }
    )
  },
  logoutUser: ({ commit }) => {
    commit('resetAuthData')
    eventsGlobal('logout', {
      'evt_category': 'account',
      'evt_button_label': 'logout_click'
    })
    if (state.formLogin) {
      Router.push({name: 'login'})
    }
    else {
      window.location.href = process.env.SSO_URL + '/logout?return_url=' + process.env.B2B_URL + '/c/portal/logout'
    }
  },
  searchOrders: ({ commit }, searchConfig) => {
    commit('searchLoading', true)
    commit('resetOrdersList')
    commit('changeSearchConfig', searchConfig)

    containerReload('search_keywords', searchConfig.keywords)

    var params = {
      keywords: searchConfig.keywords,
      status: searchConfig.status.toString(),
      notifications: searchConfig.flags.toString(),
      period: searchConfig.period.toString()
    }

    return Vue.http.get(process.env.API_URL + '/orders/search', { params: params }).then(
    response => {
      commit('searchLoading', false)
      commit('receivedOrders', response.body)
      Router.push({ name: 'order-list' })
    },
    response => {
      commit('searchLoading', false)
      Router.push({ name: 'order-list' })
      // TODO Popin alerte
      console.log('get search orders failed in store', response)
    }
    )
  },
  getOrderDetails: ({ commit }, orderId) => {
    commit('resetOrderDetails')
    return Vue.http.get(process.env.API_URL + '/orders/' + orderId).then(
    response => {
      commit('receivedOrderDetails', response.body)
    },
    response => {
      // TODO Popin alerte
      console.log('get order details failed in store', response)
    }
    )
  },
  getUserInfo: ({ commit }, token) => {
    return Vue.http.get(process.env.API_URL + '/login/info', { FormParam: token }).then(
    response => {
      commit('setUser', {
        id: response.body.CRMID,
        email: response.body.email,
        groups: response.body.extranetGroup,
        hasEshop: response.body.hasEshop
      })
    },
    response => {
      // TODO Popin alerte
      console.log('get user info failed in store', response)
    })
  }
}

const mutations = {
  filters: (state, filters) => {
    console.log('mutation filters', filters[0].id)
    state.filters = filters
  },
  setUser: (state, user) => {
    state.user = user
    window.localStorage.setItem('user', JSON.stringify(user))

    // Set the tC vars
    window.tc_vars['user_id'] = user.id
    window.tc_vars['user_email'] = user.email
    window.tc_vars['user_groups'] = user.groups
  },
  userAuthSuccess: (state, token) => {
    state.authToken = token
    window.localStorage.setItem('authToken', token)
    state.authError = null

    // console.log('userAuthSuccess >>> Storing token in state.authToken')
  },
  userAuthFail: (state, error) => {
    state.authToken = null
    window.localStorage.setItem('authToken', null)
    state.authError = error
  },
  resetAuthData: state => {
    state.authToken = null
    state.user = null
    window.localStorage.removeItem('authToken')
    window.localStorage.removeItem('user')
    state.authError = null
  },
  resetOrdersList: state => {
    state.orders = []

    var notifTab = _.find(state.filters, item => {
      return item.id === 'notifications'
    })

    // console.log('notifTab', notifTab)
    if (notifTab) {
      notifTab.counter = 0
    }
  },
  resetOrderDetails: state => {
    state.currentFilter = 'recents'
    state.currentOrder = null
  },

  changeCurrentFilter: (state, filterName) => {
    state.currentFilter = filterName
  },
  searchLoading: (state, loading) => {
    state.searchLoading = loading
  },
  changeSearchConfig: (state, searchConfig) => {
    state.searchConfig = searchConfig
  },
  receivedOrders: (state, orders) => {
    state.orders = orders

    // Update notif counter
    // console.log('notifTab', notifTab)

    var notifTab = _.find(state.filters, item => {
      return item.id === 'notifications'
    })

    if (notifTab) {
      notifTab.counter = _.filter(state.orders, value => {
        return value.delivery && (value.delivery.dateIsDifferent || value.delivery.dateHasChanged)
      }).length
    }

    // console.log('state.filters after', state.filters)
  },
  receivedOrderDetails: (state, order) => {
    state.currentOrder = order
  }
}

/* eslint-disable no-new */
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/Store.js